import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "./NDayGuarantee.module.css";
var NDayGuarantee = function NDayGuarantee(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.container, props.className ? props.className : undefined].join(" "),
    style: props.style
  }, /*#__PURE__*/React.createElement("img", {
    src: props.img,
    alt: "days"
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.content
  }, /*#__PURE__*/React.createElement("strong", null, t("n_10_days_trial_money_back", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", null, t("buy_try_10_days_money", {
    ns: "web_checkout_cash"
  }))));
};
export default NDayGuarantee;